// import { Controller } from "@hotwired/stimulus"
// import { useClickOutside, useIntersection, useTransition } from 'stimulus-use'
// import { useTransition } from 'stimulus-use'
import axios from "axios"
import DropdownController from "./dropdown_controller"
import { template } from "lodash"
const debounce = require("lodash/debounce")
// import { IntersectionController } from 'stimulus-use'
// import { useTransition } from 'stimulus-use/dist/use-transition'

/* przykład użycia: app/views/design/uix/stimulus.html.erb */

export default class extends DropdownController {
  static targets = ["menu", "input", "list", "searchWait", "selectId", "resourceTemplate", "selected"]

  eventCreated = false

  connect() {
    console.log("connect1")
    super.connect()
    // this.menuTarget.classList.add('hidden')
    this.resourceTemplate = template(this.resourceTemplateTarget.innerHTML)

    // useTransition(this, { element: this.menuTarget })

    this.updateSearchDebounce = debounce(this.updateSearchDebounce, 1000).bind(this)

    const selectedId = this.selectedTarget.value
    if (selectedId) {
      const initEvent = document.createEvent("HTMLEvents")
      initEvent.params = { id: selectedId }
      initEvent.name = "init"
      this.fillDropdown(initEvent)
    }
  }

  fillDropdown(event) {
    // select_id powinien miec format "TO_ID_SELECTA_Z_FORMULARZA", wtedy tym dropdownem mozemy wypelnic wlasciwy select w formularzu
    let selectId = this.selectIdTarget.value
    let chosenId = event.params.id
    console.log(chosenId + " " + selectId)

    const headerAvatar = document.getElementById(selectId + "_avatar")
    const headerName = document.getElementById(selectId + "_name")
    const selectedAvatar = document.getElementById(selectId + "_avatar_" + chosenId)
    const selectedName = document.getElementById(selectId + "_name_" + chosenId)

    selectId = selectId.split("to_")[1]
    const selectElement = document.getElementById(selectId)

    if (headerName !== null && selectedName !== null) {
      headerName.innerHTML = selectedName.innerText
    }
    if (selectedAvatar !== null) {
      headerAvatar.innerHTML = selectedAvatar.innerHTML
    } else {
      headerAvatar.innerHTML = ""
    }

    chosenId = chosenId === 0 ? "" : chosenId
    selectElement.value = chosenId

    if (event.name !== "init") {
      this.toggle()
    }
  }

  updateSearchInfoShow() {
    this.searchWaitTarget.classList.remove("hidden")
    this.searchWaitTarget.classList.add("block")
  }

  updateSearchInfoHide() {
    this.searchWaitTarget.classList.add("hidden")
    this.searchWaitTarget.classList.remove("block")
  }

  updateSearch(event) {
    this.updateSearchInfoShow()
    this.updateSearchDebounce(event)
  }

  updateSearchDebounce(event) {
    console.log("update")
    const input = this.inputTarget.value
    const url = this.inputTarget.dataset.url
    console.log(encodeURIComponent(input))
    console.log(this.listTarget.innerHTML)

    event.preventDefault()

    axios.get(url, {
      params: {
        query: encodeURIComponent(input)
      },
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    })
      .then(response => {
        console.log("update success")
        console.log(response.data)
        this.updateSearchInfoHide()

        this.listTarget.innerHTML = ""

        if (response.data.length > 0) {
          response.data.forEach((element) => {
            console.log(element.name + " " + element.id)
            this.itemData = {
              id: element.id,
              name: element.name,
              image_url: element.image_url
            }

            this.listTarget.innerHTML += this.resourceTemplate(this.itemData)
            this.addImage(this.itemData)
          })
        } else {
          this.updateSearchInfoHide()
        }
      })
      .catch(error => {
        console.log("error updating", error)
        this.updateSearchInfoHide()
      })
  }

  addImage(data) {
    if (data.image_url) {
      const img = document.createElement("img")
      const target = this.selectIdTarget.value + "_avatar_" + data.id

      img.src = data.image_url
      img.alt = ""
      img.width = 25
      img.height = 25
      img.classList.add("circle-image")
      img.style.borderRadius = "50%"

      document.getElementById(target).appendChild(img)
      document.getElementById(target).style.marginRight = "10px"
    }
  }
}
